import LoginProfileData from "./login-profile-data";

export default LoginProfileData;
